import { uniq } from 'lodash-es';
import WebFontLoader from 'webfontloader';

export default class FontHelper {
  static loadedFontCache: string[] = [];

  static loadWebFont(data) {
    let families = [];

    const handleWithFont = (fontData) => {
      const fontFormatted = this.getFontFamilyString(fontData.font, fontData.weights);

      if (fontFormatted) {
        families.push(fontFormatted);
      }
    };

    if (Array.isArray(data)) {
      data.forEach((datum) => handleWithFont(datum));
    } else {
      handleWithFont(data);
    }

    families = uniq(families);

    return new Promise((resolve) => {
      if (families.length > 0) {
        WebFontLoader.load({
          google: {
            families,
          },

          fontactive: () => {
            families.forEach((family) => {
              this.loadedFontCache.push(family);
            });

            resolve();
          },
        });
      } else {
        resolve();
      }
    });
  }

  static getFontFamilyString(font, weights) {
    const formattedWeights = weights.map((weight) =>
      weight && weight.toString().includes('italic') ? weight.replace(/\s/g, '') : weight,
    );
    const fontFormatted = `${font}:${formattedWeights.join(',')}`;

    return this.loadedFontCache.includes(fontFormatted) ? null : fontFormatted;
  }
}
